import React from 'react';
import { Star, MapPin } from 'lucide-react';

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="testimonial-card">
      <div style={{marginBottom: '20px'}}>
        <div style={{display: 'flex', gap: '4px', marginBottom: '16px'}}>
          {[...Array(testimonial.rating)].map((_, i) => (
            <Star key={i} size={16} fill="var(--brand-primary)" color="var(--brand-primary)" />
          ))}
        </div>
        <p className="body-medium" style={{color: 'var(--text-primary)', lineHeight: '1.6', marginBottom: '20px'}}>
          "{testimonial.text}"
        </p>
      </div>
      <div style={{borderTop: '1px solid var(--border-medium)', paddingTop: '16px'}}>
        <p className="heading-6" style={{color: 'var(--text-primary)', marginBottom: '4px'}}>{testimonial.name}</p>
        <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px'}}>
          <MapPin size={14} color="var(--text-secondary)" />
          <span className="body-small" style={{color: 'var(--text-secondary)'}}>{testimonial.location}</span>
        </div>
        <span className="caption" style={{color: 'var(--brand-primary)'}}>{testimonial.service}</span>
      </div>
    </div>
  );
};

export default TestimonialCard;